<template>
  <div>
    <el-link class="user"
             @click="dialogFormVisible=true"
             type="warning"
             :underline="false">
      <i class="el-icon-user-solid" style="margin-right: 5px"></i>
      {{user.firstname }}
      {{user.lastname }}
    </el-link>
    <el-button type="primary"
               size="mini"
               @click="dialogFormVisible=true"
               icon="el-icon-search">se connecter
    </el-button>
    <el-divider></el-divider>
    <el-dialog title="entrez le mot de passe"
               :visible.sync="dialogFormVisible"
               :width="shouldGoResponsive()">
      <UserForm @passwordTry="authTry($event)"></UserForm>
    </el-dialog>
  </div>
</template>

<script>
import UserForm from './UserForm.vue';

export default {
  components: {
    UserForm,
  },
  props: {
    user: undefined,
  },
  data() {
    return {
      dialogFormVisible: false,
    };
  },
  methods: {
    authTry(password) {
      this.$emit('authTry', {
        mail: this.user.email,
        password,
      });
    },
    shouldGoResponsive() {
      const width = window.screen.availWidth;
      return width < 800 ? '100%' : '50%';
    },
  },
};
</script>

<style lang="stylus">
  .user
    justify-content left
    width 200px
    margin-right 10px

  el-button
    color #2a8eec !important
</style>
